import DefaultMonitoringDetails from "src/components/feature/MonitoringDetails";

const MonitoringDetails = () => {
  return <DefaultMonitoringDetails />;
};

export default MonitoringDetails;
